import React, {useState, useEffect, useCallback} from 'react'
/** @jsxImportSource @emotion/react */
import {css} from '@emotion/react'

import {shuffle} from 'lodash'

import useMediaQuery from '@mui/material/useMediaQuery'

import {connect, useDispatch} from 'react-redux'

import {get} from 'lodash'

import {show} from '../../../apis'

import {useIsMounted, useFetchFavoritesOfType} from '../../../hooks'

import { 
  makeGetBandById,
  selectBandLinks,
  makeGetBandTracks, 
  selectBandFetchedAssociations
} from '../../../selectors'

import { 
  index,
  saveLinks,
  addTracksToBand,
  setFetchedAssociations,
  removeSpotifyTracksFromBand
} from '../../../actions'


import {
  convertSpotifyTracksToCkordFormat,
  convertAppleMusicTracksToCkordFormat
} from '../../../helpers'


import AddIcon from '@mui/icons-material/Add'
import Dialog from '@mui/material/Dialog'

import {TrackForm} from '../../track'
import {CardList, CardListMobile} from '../../cards'


import { 
  GroupedButton,
  ThreeDotProgress, 
  SlideTransition,
  FadeTransition,
  DetailPageTabMessage,
  DetailPageTabButtonContainer
} from '../../generics'




const styles = {
  root: css`
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    align-content: center;
    justify-content: flex-start;
    flex-direction: column;
  `,
  section: css`
    width: 100%;
    display: flex;
    flex-direction: column;
    margin-bottom: 60px;

    h4 {
      font-size: 1.3rem;
      font-weight: 600;
      color: #7b7b7b;
      letter-spacing: 0;
      margin-left: 15px;
      margin-right: 15px;
      margin-bottom: 15px;
      padding-bottom: 10px;
      border-bottom: 1px solid #d9d9d9;
      margin-top: 10px;
    }
  `,
  cardsContainer: css`
    display: flex;
    flex-wrap: wrap;
    max-width: 100%;
    width: 100%;

    .message {
      width: 100%;
      font-size: 1rem;
      text-align: left;
      padding-left: 15px;
      margin-bottom: 15px;
    }
  `,
  progressContainer: css`
    height: 100%;
    width: 100%;
    margin-top: 20px;
  `,
  dialog: css`
    backdrop-filter: blur(10px);
  `
}




const BandTracks = props => {

  const isMounted = useIsMounted()

  const dispatch = useDispatch()

  const isExtraSmallScreen = useMediaQuery(theme => theme.breakpoints.only('xs'))

  const [open, setOpen] = useState(false)


  const { 
    bandId,  
    tracks,
    index,
    isLoaded,
    isFetching,
    permission,
    saveLinks,
    stateLinks,
    // spotifyLink,
    appleMusicLink,
    addTracksToBand,
    setFetchedAssociations,
    removeSpotifyTracksFromBand
  } = props


  const [links, setLinks] = useState(stateLinks)

  const [isFetched, setIsFetched] = useState(isLoaded)

  const hasNextPage = links.pages !== links.page





  const fetchMoreTracks = useCallback(props => {
    if (links.pages !== links.page) {
      const url = links.next_url.slice(4)

      index(url, 'TRACKS').then(response => {
        addTracksToBand(bandId, response.data)

        if (isMounted.current) {
          if (props.isMounted && props.isMounted.current && props.setIsFetching) {
            props.setIsFetching(false)
          }
          
          if (response.links) {
            setLinks(response.links)
          }
          
          setIsFetched(true)  
        }
      })
    }
  }, [
    index,
    bandId,
    isMounted,
    links.page,
    links.pages,
    links.next_url,
    addTracksToBand
  ])



  useEffect(() => {
    return () => saveLinks('BAND', bandId, 'tracks', links)
  }, [bandId, links, saveLinks])



  useEffect(() => {
    if (!isLoaded) {
      setFetchedAssociations('BAND', bandId, 'tracks')
      
      index('/bands/' + bandId + '/tracks', 'TRACKS').then(response => {
        addTracksToBand(bandId, response.data)

        if (isMounted.current) {
          setIsFetched(true)

          if (response.links) {
            setLinks(response.links)
          }
        }
      })
    }
  }, [
    index,
    bandId, 
    isLoaded,
    isMounted,
    addTracksToBand,
    setFetchedAssociations
  ])




  // Get Spotify previews of tracks if user has a Spotify link
  // useEffect(() => {
  //   const spotifyArtistID = spotifyLink?.split('?')[0].split('/').reverse()[0]


  //   if (!spotifyArtistID) return

  //   // Since this effect should only run once, if it runs a second time it means
  //   // the band changed the spotfiy link and therefore the current spotify tracks
  //   // should be removed before the new ones are added
  //   removeSpotifyTracksFromBand(bandId)

    
  //   show('/services/spotify/artists/' + spotifyArtistID + '/tracks').then(response => {
  //     const data = response.data

  //     // Format the Spotify tracks to match the Ckord tracks
  //     const ckordTracks = shuffle(convertSpotifyTracksToCkordFormat(data, bandId, 'Band', spotifyLink))


  //     // Update the store
  //     dispatch({type: 'TRACKS_INDEX_SUCCESS', payload: {data: ckordTracks}})
  //     addTracksToBand(bandId, ckordTracks)
  //   })
  //   .catch(error => {})
  // }, [
  //   bandId,
  //   dispatch,
  //   spotifyLink,
  //   addTracksToBand,
  //   removeSpotifyTracksFromBand
  // ])



  useEffect(() => {
    const appleMusicArtistID = appleMusicLink?.split('?')[0].split('/').reverse()[0]


    if (!appleMusicArtistID) return


    // Since this effect should only run once, if it runs a second time it means
    // the artist changed the spotfiy link and therefore the current spotify tracks
    // should be removed before the new ones are added
    // removeSpotifyTracksFromArtist(artistId)

    
    show('/services/apple-music/artists/' + appleMusicArtistID + '/tracks').then(response => {
      const data = response.data
      
      // Format the Spotify tracks to match the Ckord tracks
      const ckordTracks = convertAppleMusicTracksToCkordFormat(data, bandId, 'Band', appleMusicLink)

      // Update the store
      dispatch({type: 'TRACKS_INDEX_SUCCESS', payload: {data: ckordTracks}})
      addTracksToBand(bandId, ckordTracks)
    })
    .catch(error => console.log(error))
  }, [
    bandId, 
    dispatch, 
    appleMusicLink, 
    addTracksToBand
    // removeSpotifyTracksFromBand
  ])



  useFetchFavoritesOfType('track')



  function handleClick() {
    setOpen(true)
  }



  function close() {
    setOpen(false)
  }




  return (
    <div css={styles.root}>
      <DetailPageTabButtonContainer>
        {['owner', 'editor'].includes(permission) && 
          <GroupedButton 
            text='New'
            tip='Add new track'
            icon={<AddIcon />}
            onClick={handleClick}  
          /> 
        }
      </DetailPageTabButtonContainer>



      <section css={styles.section}>
        {Boolean(tracks.length) &&
          <>
            {isExtraSmallScreen &&
              <CardListMobile
                type='track'
                cards={tracks}
                hasNextPage={hasNextPage}
                fetchMoreItems={fetchMoreTracks}
              />
            }


            {!isExtraSmallScreen &&
              <CardList 
                type='track'
                cards={tracks}
                hasNextPage={hasNextPage}
                fetchMoreItems={fetchMoreTracks}
              /> 
            }
          </>
        }



        {!Boolean(tracks.length) && isFetched &&
          <DetailPageTabMessage>
            {['owner', 'editor'].includes(permission)
              ? 'To add / upload a music track, click the plus icon above' 
              : 'This artist hasn\'t uploaded any tracks yet'
            }
          </DetailPageTabMessage>
        }




        {isFetching && 
          <div css={styles.progressContainer}>
            <ThreeDotProgress position='sticky' /> 
          </div>
        }
      </section>



      <Dialog
        open={open}
        onClose={close}
        css={styles.dialog}
        disableScrollLock
        fullScreen={isExtraSmallScreen}
        maxWidth='xs'
        fullWidth={true}
        TransitionComponent={isExtraSmallScreen ? SlideTransition : FadeTransition}
      >
        <TrackForm creatorId={bandId} creatorType='band' close={close} />
      </Dialog>
    </div>
  )
}




const makeMapStateToProps = () => {
  const getBandById = makeGetBandById()
  const getBandTracks = makeGetBandTracks()
  

  const mapStateToProps = (state, props) => {
    const id = props.bandId

    const band = getBandById(state, id)

    const tracks = getBandTracks(state, id)
    
    const links = selectBandLinks(state, id, 'tracks')
    
    const role = get(state, ['user', 'attributes', 'role'])



    return {
      tracks: tracks,
      stateLinks: links,
      // spotifyLink: band?.attributes?.links?.spotify,
      appleMusicLink: band?.attributes?.links?.apple,
      isFetching: state.tracks.isFetching && tracks.length === 0,
      isLoaded: selectBandFetchedAssociations(state, id).includes('tracks'),
      permission: ['admin', 'editor'].includes(role) ? 'owner' : band.permission,
    }
  }

  return mapStateToProps
}


const actions = {
  index,
  saveLinks, 
  addTracksToBand,
  setFetchedAssociations,
  removeSpotifyTracksFromBand
}


export default connect(makeMapStateToProps, actions)(BandTracks)




